import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface PasswordMetaData {
    enteredPassword: string,
    enteredPasswordAgain: string,
    charLimitCheck?: boolean,
    specialCharCheck?: boolean,
    uppercaseCheck?: boolean,
    lowercaseCheck?: boolean,
    passwordMatch?: boolean,
}

export const initialState: PasswordMetaData = {
    enteredPassword: "",
    enteredPasswordAgain: "",
    charLimitCheck: false,
    specialCharCheck: false,
    uppercaseCheck: false,
    lowercaseCheck: false,
    passwordMatch: false
}

const passwordSlice = createSlice({
    name: 'password',
    initialState,
    reducers: {
        setEnteredPassword: (state: PasswordMetaData, action: PayloadAction<string>) => {
            state.enteredPassword = action.payload
        },
        setEnteredPasswordAgain: (state: PasswordMetaData, action: PayloadAction<string>) => {
            state.enteredPasswordAgain = action.payload
        },
        setCharLimitCheck: (state: PasswordMetaData, action: PayloadAction<boolean>) => {
            state.charLimitCheck = action.payload
        },
        setSpecialCharCheck: (state: PasswordMetaData, action: PayloadAction<boolean>) => {
            state.specialCharCheck = action.payload
        },
        setUppercaseCheck: (state: PasswordMetaData, action: PayloadAction<boolean>) => {
            state.uppercaseCheck = action.payload
        },
        setLowercaseCheck: (state: PasswordMetaData, action: PayloadAction<boolean>) => {
            state.lowercaseCheck = action.payload
        },
        setPasswordMatch: (state: PasswordMetaData, action: PayloadAction<boolean>) => {
            state.passwordMatch = action.payload
        },
        resetPasswordStates: () => initialState
    }
});

export const { setEnteredPassword, setEnteredPasswordAgain, setCharLimitCheck, setSpecialCharCheck, setUppercaseCheck, setLowercaseCheck, setPasswordMatch, resetPasswordStates } = passwordSlice.actions;

export default passwordSlice.reducer;
